export default (num) => {
  const notApplicable = 'n/a';
  if (num == notApplicable) return notApplicable;
  if (num > 0) return 'increase';
  if (num < 0) return 'decrease';
  return 'same';
};
